var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBDeactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.374,
    height: 28.147,
    viewBox: "0 0 38.374 28.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21267",
    "data-name": "Path 21267",
    d: "M45.123,58a1.279,1.279,0,0,1-.98,2.1H17.281A1.279,1.279,0,0,1,16.3,58a19.039,19.039,0,0,1,8.661-5.943,10.873,10.873,0,1,1,11.5,0A19.052,19.052,0,0,1,45.123,58ZM53.1,47.316H45.422a1.279,1.279,0,1,0,0,2.558H53.1a1.279,1.279,0,0,0,0-2.558Z",
    transform: "translate(-16.002 -31.96)",
    fill: "#cb2929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBDeactive);
export default __webpack_public_path__ + "static/media/bDeactive.bd97803208e82233e17cbb80e19093d1.svg";
export { ForwardRef as ReactComponent };